/* global $, newsletterPopupCount, Swiper, swiperPopup */
$(function () {
    var root = $('#s31-personalizedPopup-root');
    if (!root.length) {
        return;
    }

    // 10. Exit-intent opuštěného košíku po zobrazení nespouštět
    $(document).on('show.bs.modal', '#ouibounce-modal', function (e) {
        if (window.pwPersonalizedPopupShown) {
            e.preventDefault();
        }
    });

    function markDone() {
        try {
            if (window.sessionStorage) {
                sessionStorage.setItem('pwPpDone', '1');
            }
        } catch (e) {
            // sessionStorage blocked or unavailable
        }
    }

    // 2. Počítadlo stránek v návštěvě
    var pageviews = 0;
    try {
        if (window.sessionStorage) {
            if (sessionStorage.getItem('pwPpDone') === '1') {
                return;
            }
            var pv = parseInt(sessionStorage.getItem('pwPpPageviews'), 10);
            if (isNaN(pv)) {
                pv = 0;
            }
            pv += 1;
            sessionStorage.setItem('pwPpPageviews', pv.toString());
            pageviews = pv;
        }
    } catch (e) {
        return;
    }

    var minPageviews = parseInt(root.attr('data-min-pageviews'), 10);
    if (isNaN(minPageviews)) {
        minPageviews = 0;
    }
    if (pageviews < minPageviews) {
        return;
    }

    // 3. Ověření podmínek po zpoždění
    var delaySeconds = parseInt(root.attr('data-delay'), 10);
    if (isNaN(delaySeconds) || delaySeconds < 0) {
        delaySeconds = 0;
    }

    var newsletterDeferred = false;
    var retryCount = 0;
    var maxRetries = 6;

    function checkConditionsAndRun() {
        try {
            if (window.sessionStorage && sessionStorage.getItem('pwPpDone') === '1') {
                return;
            }
        } catch (e) {}

        // Newsletter se na této stránce otevírá
        if (typeof newsletterPopupCount !== 'undefined' && newsletterPopupCount === 3) {
            if (!newsletterDeferred) {
                newsletterDeferred = true;
                setTimeout(checkConditionsAndRun, 20000);
                return;
            } else {
                return;
            }
        }

        var isModalVisible = $('.modal.show').filter(':visible').length > 0;
        var htmlEl = document.documentElement;
        var isCookieOpen = false;
        if (htmlEl && htmlEl.classList) {
            if (htmlEl.classList.contains('show--consent') || htmlEl.classList.contains('show--preferences')) {
                isCookieOpen = true;
            }
        }

        if (isModalVisible || isCookieOpen) {
            if (retryCount < maxRetries) {
                retryCount++;
                setTimeout(checkConditionsAndRun, 5000);
                return;
            } else {
                return;
            }
        }

        fetchOffer();
    }

    setTimeout(checkConditionsAndRun, delaySeconds * 1000);

    // 4. Dotaz na nabídku
    function fetchOffer() {
        var offerUrl = root.attr('data-url');
        var impressionUrl = root.attr('data-impression-url');

        $.ajax({
            url: offerUrl,
            method: 'GET',
            dataType: 'json',
            cache: false,
            statusCode: {
                204: function () {
                    markDone();
                }
            },
            success: function (data, textStatus, xhr) {
                if (xhr.status === 204 || !data) {
                    markDone();
                    return;
                }

                // 5. Kontrolní skupina (A/B control)
                if (data.control === true) {
                    $.ajax({
                        url: impressionUrl,
                        method: 'POST'
                    });

                    window.dataLayer = window.dataLayer || [];
                    dataLayer.push({
                        event: 'pw_personalized_popup_control',
                        pw_opportunity_id: data.opportunityId,
                        pw_opportunity_type: data.opportunityType,
                        pw_theme_code: data.themeCode,
                        pw_impression: data.impressionNumber
                    });

                    markDone();
                    return;
                }

                // 6. Zobrazení pop-upu
                if (!data.html) {
                    markDone();
                    return;
                }

                $('body').append(data.html);
                var popup = $('#s31-personalizedPopup');
                if (!popup.length) {
                    markDone();
                    return;
                }

                popup.one('shown.bs.modal', function () {
                    $.ajax({
                        url: impressionUrl,
                        method: 'POST'
                    });

                    markDone();
                    window.pwPersonalizedPopupShown = true;

                    var hasBenefit = data.benefit ? 1 : 0;
                    window.dataLayer = window.dataLayer || [];
                    dataLayer.push({
                        event: 'pw_personalized_popup_open',
                        pw_opportunity_id: data.opportunityId,
                        pw_opportunity_type: data.opportunityType,
                        pw_theme_code: data.themeCode,
                        pw_impression: data.impressionNumber,
                        pw_has_benefit: hasBenefit
                    });

                    // Položky v pop-upu pro view_item_list
                    var items = [];
                    popup.find('article.s31-article-box').each(function (idx) {
                        var art = $(this);
                        var itemCode = art.data('code') || art.attr('data-code') || '';
                        var itemName = art.data('name') || art.attr('data-name') || '';
                        var itemCategory = art.data('category') || art.attr('data-category') || '';
                        var itemPrice = 0;
                        var itemPriceDiv = art.find('.s31-article-price[data-price]');
                        if (itemPriceDiv.length > 0) {
                            var itemPriceRaw = itemPriceDiv.data('price');
                            var itemPriceParse = parseFloat(itemPriceRaw) / 100;
                            if (!isNaN(itemPriceParse)) {
                                itemPrice = itemPriceParse;
                            }
                        }
                        items.push({
                            item_id: itemCode,
                            item_name: itemName,
                            item_category: itemCategory,
                            price: itemPrice,
                            index: idx,
                            item_list_id: 'pw_personalized_popup',
                            item_list_name: 'Personalized popup'
                        });
                    });

                    dataLayer.push({ ecommerce: null });
                    dataLayer.push({
                        event: 'view_item_list',
                        ecommerce: {
                            item_list_id: 'pw_personalized_popup',
                            item_list_name: 'Personalized popup',
                            items: items
                        }
                    });

                    // Swiper inicializace
                    if (typeof Swiper !== 'undefined') {
                        var swiperEl = popup.find('.swiper-popup');
                        if (swiperEl.length > 0) {
                            new Swiper(swiperEl[0], {
                                loop: false,
                                slidesPerView: 1,
                                spaceBetween: 0,
                                slidesPerGroup: 1,
                                breakpoints: {
                                    320: { slidesPerView: 2, slidesPerGroup: 1 },
                                    545: { slidesPerView: 2, slidesPerGroup: 1 },
                                    737: { slidesPerView: 4, slidesPerGroup: 1 },
                                    961: { slidesPerView: 4, slidesPerGroup: 1 },
                                    1169: { slidesPerView: 4, slidesPerGroup: 1 },
                                    1419: { slidesPerView: 4, slidesPerGroup: 1 }
                                },
                                navigation: {
                                    nextEl: swiperEl.find('.swiper-button-popup-next')[0] || '.swiper-button-popup-next',
                                    prevEl: swiperEl.find('.swiper-button-popup-prev')[0] || '.swiper-button-popup-prev'
                                }
                            });
                        }
                    } else if (typeof swiperPopup !== 'undefined' && swiperPopup.update) {
                        swiperPopup.update();
                    }
                });

                popup.modal('show');
            },
            error: function () {
                // Tichý konec při chybě
            }
        });
    }

    // 7. Klik na produkt v pop-upu
    $(document).on('click', '#s31-personalizedPopup .from-personalizedPopup', function () {
        var link = $(this);
        var article = link.closest('article.s31-article-box');
        if (!article.length) {
            return;
        }

        var itemCode = article.data('code') || article.attr('data-code') || '';
        var itemName = article.data('name') || article.attr('data-name') || '';
        var itemCategory = article.data('category') || article.attr('data-category') || '';
        var itemPrice = 0;
        var itemPriceDiv = article.find('.s31-article-price[data-price]');
        if (itemPriceDiv.length > 0) {
            var itemPriceRaw = itemPriceDiv.data('price');
            var itemPriceParse = parseFloat(itemPriceRaw) / 100;
            if (!isNaN(itemPriceParse)) {
                itemPrice = itemPriceParse;
            }
        }

        var idx = article.closest('.swiper-slide').index();
        if (idx < 0) {
            idx = 0;
        }

        window.dataLayer = window.dataLayer || [];
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: 'select_item',
            ecommerce: {
                item_list_id: 'pw_personalized_popup',
                item_list_name: 'Personalized popup',
                items: [{
                    item_id: itemCode,
                    item_name: itemName,
                    item_category: itemCategory,
                    price: itemPrice,
                    index: idx,
                    item_list_id: 'pw_personalized_popup',
                    item_list_name: 'Personalized popup'
                }]
            }
        });
    });

    // 8. Kopírovat kód
    function fallbackCopy(text) {
        var textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.top = '-9999px';
        textArea.style.left = '-9999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
            document.execCommand('copy');
        } catch (err) {}
        document.body.removeChild(textArea);
    }

    $(document).on('click', '#s31-personalizedPopup [data-pw-code]', function (e) {
        e.preventDefault();
        var btn = $(this);
        var code = btn.attr('data-pw-code') || '';
        var opportunityId = $('#s31-personalizedPopup').attr('data-pw-opportunity-id') || '';

        if (code) {
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(code).catch(function () {
                    fallbackCopy(code);
                });
            } else {
                fallbackCopy(code);
            }
        }

        var originalText = btn.text();
        var copiedLabel = btn.attr('data-copied-label') || 'Zkopírováno';
        btn.text(copiedLabel);
        setTimeout(function () {
            btn.text(originalText);
        }, 2000);

        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event: 'pw_personalized_popup_copy_code',
            pw_opportunity_id: opportunityId
        });
    });

    // 8. Uplatnit kód
    $(document).on('click', '#s31-personalizedPopup .s31-personalizedPopup-applyBtn', function () {
        var opportunityId = $('#s31-personalizedPopup').attr('data-pw-opportunity-id') || '';
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event: 'pw_personalized_popup_apply_code',
            pw_opportunity_id: opportunityId
        });
    });

    // 9. Zavření modalu
    $(document).on('hidden.bs.modal', '#s31-personalizedPopup', function () {
        var opportunityId = $(this).attr('data-pw-opportunity-id') || '';
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event: 'pw_personalized_popup_close',
            pw_opportunity_id: opportunityId
        });
    });
});
